import Deprecating from '../../../../../../DEPRECATING.md';
import * as React from 'react';
export default {
  Deprecating,
  React
};